import { useEffect } from 'react';
import spacetime from 'spacetime';
import { click } from 'analytics/utilities';

export const roundMilliseconds = (milliseconds) => Math.round(milliseconds / 100) * 100;

export const useTrackLoadTime = (loadEventName, loadEventProps) => {
  useEffect(() => {
    const initMountTime = spacetime.now();
    return () => {
      if (loadEventName) {
        const endTime = initMountTime.diff(spacetime.now(), 'milliseconds');
        click(loadEventName)({
          ...loadEventProps,
          loadTime: roundMilliseconds(endTime),
          originalLoadTime: endTime
        });
      }
    };
  }, []);
};

export default useTrackLoadTime;
